/*

# Dependencies
	- mod.js
	- mod.observer.js
	- jquery 1.7+

*/

(function($, mod) {
	"use strict";

	var defaultParams = {
		animate : true,
		data : {},
		callback : function() {}
	};

	mod.sections = {

		// The container that holds all the sections on the page
		_$sections : null,

		switchTo : function(name, params) {
			this._$sections = this._$sections || $("div.sections");
			var activeSection = this._$sections.attr("data-active");

			// Make sure it changed
			if (name !== activeSection) {
				params = $.extend(true, {}, defaultParams, params);
				var allSections = this._$sections.find("div.section");

				for (var i = 0, len = allSections.length; i < len; i++) {
					var section = allSections[i];
					var sectionName = section.getAttribute("data-section");
					var $section = $("#" + section.id);

					if (sectionName === name) {
						this._loadSection($section, params, activeSection);
						this._$sections.attr("data-active", name);

						break;
					}
				}
			}
			else {
				params.callback && params.callback();
			}
		},

		_loadSection : function($toSection, params, oldSectionId) {
			var loadData = params.data;
			var doAnimation = params.animate;
			var callback = params.callback;
			var $fromSection = this._$sections.find("div[data-section='" + oldSectionId + "']");

			this._positionSection($toSection, doAnimation, callback, $fromSection);

			if ($toSection.hasClass("loading")) {
				mod.modules.widgetapi.load({
					widgets: {
						appId: $toSection.attr("data-widgetid"),
						context: loadData
					}
				});
			}
			else {
				$toSection.addClass("active");
			}
		},

		_positionSection : function($toSection, doAnimation, callback, $fromSection) {
			var self = this;
			var newPosition = $toSection.position().left * -1;

			$toSection.addClass("active");

			if (doAnimation) {
				this._$sections.animate(
					{ left: newPosition },
					200,
					function() {
						self._positionSectionComplete($fromSection, $toSection, callback);
					}
				);
			}
			else {
				this._$sections.css("left", newPosition);
				this._positionSectionComplete($fromSection, $toSection, callback);
			}
		},

		_positionSectionComplete: function($fromSection, $section, callback) {
			$fromSection.removeClass("active");
			mod.observer.trigger("section - changed", $section);
			callback && callback();
		}

	};

}(jQuery, window.mod));